module.exports = __webpack_public_path__ + "static/img/logo68.d9d067c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo68.png
// module id = dswo
// module chunks = 1